import { Link } from 'react-router-dom';

export interface InfrastructureCounts {
  containers?: { total: number; running?: number };
  volumes?: number;
  networks?: number;
  stacks?: number;
  services?: number;
}

export interface InfrastructurePanelProps {
  counts: InfrastructureCounts;
}

const DASH = '—';

/** Resource counts, each linking to its list page. Wrap in a Panel on the page. */
export function InfrastructurePanel({ counts }: InfrastructurePanelProps) {
  const rows: Array<{ label: string; to: string; value?: number; detail?: string }> = [
    {
      label: 'Containers',
      to: '/resources/containers',
      value: counts.containers?.total,
      detail: counts.containers?.running !== undefined ? `${counts.containers.running} running` : undefined,
    },
    { label: 'Volumes', to: '/resources/volumes', value: counts.volumes },
    { label: 'Networks', to: '/resources/networks', value: counts.networks },
    { label: 'Stacks', to: '/resources/stacks', value: counts.stacks },
    { label: 'Services', to: '/resources/services', value: counts.services },
  ];

  return (
    <ul className="divide-y">
      {rows.map((r) => (
        <li key={r.label}>
          <Link
            to={r.to}
            className="flex items-center justify-between gap-3 rounded-sm py-2 outline-none hover:bg-muted/50 focus-visible:ring-2 focus-visible:ring-ring"
          >
            <span className="font-medium">{r.label}</span>
            <span className="flex items-baseline gap-2">
              {r.detail && <span className="text-xs text-muted-foreground">{r.detail}</span>}
              <span className="font-semibold tabular-nums">{r.value ?? DASH}</span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
